import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener(
      "animationend",
      () => {
        const dayGroup = this.element.closest(".day-group")
        this.element.remove()
        if (dayGroup && !dayGroup.querySelector(".brag-card")) {
          dayGroup.remove()
        }
      },
      { once: true }
    )
  }
}
